import { debug } from "../utils";

export const ACTION_DEVICE_TYPES_CHANGED = "ACTION_DEVICE_TYPES_CHANGED";
export const ACTION_DEVICES_CHANGED = "ACTION_DEVICES_CHANGED";
export const ACTION_MSB_LIST_CHANGED = "ACTION_MSB_LIST_CHANGED";
export const ACTION_VALIDATION_RESULT_LIST_CHANGED_RECENT_VIOLATIONS_PAGE = "ACTION_VALIDATION_RESULT_LIST_CHANGED_RECENT_VIOLATIONS_PAGE";
//export const ACTION_VALIDATION_RESULT_LIST_CHANGED_ANALYSIS_PAGE = "ACTION_VALIDATION_RESULT_LIST_CHANGED_ANALYSIS_PAGE";
export const ACTION_SELECTED_DEVICE_CHANGED = "ACTION_SELECTED_DEVICE_CHANGED";
export const ACTION_RECENT_VIOLATION_TABLE_CLEARED = "ACTION_RECENT_VIOLATION_TABLE_CLEARED";

export function RecentViolationsPageReducer(state = {}, action) {
    //alert(2);
    switch (action.type) {
        case ACTION_DEVICE_TYPES_CHANGED: {
            debug(`DevicesPageReducer ${ACTION_DEVICE_TYPES_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_DEVICES_CHANGED: {
            debug(`DevicesPageReducer ${ACTION_DEVICES_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_MSB_LIST_CHANGED: {
            debug(`DevicesPageReducer ${ACTION_MSB_LIST_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_SELECTED_DEVICE_CHANGED: {
            debug(`DevicesPageReducer ${ACTION_SELECTED_DEVICE_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_VALIDATION_RESULT_LIST_CHANGED_RECENT_VIOLATIONS_PAGE: {
            debug(`DevicesPageReducer ${ACTION_VALIDATION_RESULT_LIST_CHANGED_RECENT_VIOLATIONS_PAGE} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_RECENT_VIOLATION_TABLE_CLEARED: {
            debug(`DevicesPageReducer ${ACTION_RECENT_VIOLATION_TABLE_CLEARED} is being processed...`)
            return { ...state, validationResultList: [], totalRecords: 0 }
        }
        default:
            return state;
    }
}
